import _ from 'lodash';
import { PHONE_TYPE } from '../components/PhoneForm/PhoneFormUtils';
import { isSoftDecline } from '../utils/USUtils';

// used to determine which fields live on which page.
// we redirect to certain pages if server-side validation errors occur
export const FORM_FIELDS = {
    BILLING_INFO: ['firstName', 'lastName', 'street1', 'street2', 'city', 'state', 'postalCode'],
    PERSONAL_INFO: ['dob', 'nationalId', 'phoneType', 'telephone', 'selfReportedIncome']
};

export const getInitialFormValues = (state) => {

    let phoneType = _.get(state, 'serverData.user.phoneType');
    let telephone = _.get(state, 'serverData.user.telephone');

    // default to MOBILE if invalid phone_type
    if (_.valuesIn(PHONE_TYPE).indexOf(phoneType) < 0) {
        phoneType = PHONE_TYPE.MOBILE;
    }

    // don't show SSN, DOB, or phone number for soft declines
    if (isSoftDecline(state)) {
        telephone = '';
    }

    return {
        firstName: _.get(state, 'serverData.user.firstName'),
        lastName: _.get(state, 'serverData.user.lastName'),
        street1: _.get(state, 'serverData.billingAddress.addressLine1'),
        street2: _.get(state, 'serverData.billingAddress.addressLine2'),
        city: _.get(state, 'serverData.billingAddress.city'),
        state: _.get(state, 'serverData.billingAddress.state'),
        postalCode: _.get(state, 'serverData.billingAddress.postalCode'),
        phoneType,
        telephone,
        selfReportedIncome: ''
    };
};
